<template>
    <q-page v-if="$store.state.loggedIn">
        <q-layout-header>
            <q-toolbar>
                <!-- showLeft is a model attached to left side drawer below -->
                <q-btn
                    flat round dense
                    @click="$store.commit('showLeftMenu', ! $store.state.showLeftMenu)"
                    title="Pokaż boczne menu"
                    icon="menu"
                />

                <q-toolbar-title>
                    Walk 4 Life - administracja
                </q-toolbar-title>

                <time-to-logout/>

                <global-publish-info class="q-mr-sm"/>

                <q-btn
                    v-if="hasErrors"
                    round dense
                    @click="goToErrorsPage"
                    title="Pokaż zdarzenia"
                    color="red"
                    icon="warning">
                </q-btn>

                <q-btn
                    round dense
                    @click="logout"
                    title="Wyloguj"
                    icon="logout">
                </q-btn>

            </q-toolbar>
        </q-layout-header>


        <!--left-side menu-->
        <q-layout-drawer side="left" v-model="$store.state.showLeftMenu">
            <q-list no-border link inset-separator>
                <template v-for="(item, i) in availableMenuItems">
                    <q-item :to="{name: item.route}" v-if="!item.divider" :key="i">
                        <q-item-side :icon="item.icon"/>
                        <q-item-main :label="item.text"/>
                    </q-item>
                    <q-list-header v-else v-html="item.text" :key="i"></q-list-header>
                </template>
            </q-list>
        </q-layout-drawer>

        <q-layout-drawer side="right" v-model="showRightMenu" :width="$store.state.rightMenuWidth">
            <router-view name="right"></router-view>
        </q-layout-drawer>

        <router-view class="q-pa-md"></router-view>
    </q-page>
</template>

<script>
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import GlobalPublishInfo from '../components/GlobalPublishInfo'
    import TimeToLogout from '../components/TimeToLogout'

    export default {
        components: {TimeToLogout, GlobalPublishInfo, QBtn},
        data: () => ({
            drawer: null,
            menuItems: [
                {icon: 'person', text: 'Użytkownicy administracyjni', route: 'users'},
                {icon: 'person', text: 'Użytkownicy aplikacji', route: 'ext-users'},

                {divider: true, text: 'Bieguny'},
                {icon: 'accessibility', text: 'Bieguny', route: 'goals'},
                {icon: 'timeline', text: 'Osiągnięcia', route: 'achievements'},
                // {icon: 'directions_run', text: 'Aktywności', route: 'activities'},
                {icon: 'check_box', text: 'Zadania uzupełniające', route: 'tasks'},
                {icon: 'poll', text: 'Ankiety kwalifikacyjne', route: 'surveys-qualifying', onlyForRoles: ['Admin']},
                {icon: 'text_format', text: 'Artykuły', route: 'polearticles'},
                {icon: 'directions_run', text: 'Aktywności', route: 'activities'},
                {icon: 'category', text: 'Kategorie', route: 'categories'},

                {divider: true, text: 'Media'},
                {icon: 'movie', text: 'Filmy', route: 'movies'},
                {icon: 'audiotrack', text: 'Audio', route: 'audio'},
                {icon: 'image', text: 'Zdjęcia', route: 'pictures'},
                {icon: 'verified_user', text: 'Odznaki', route: 'badges'},
                // {icon: 'record_voice_over', text: 'Komunikaty głosowe', route: 'voice-commands'},

                {divider: true, text: 'Baza wiedzy'},
                {icon: 'text_format', text: 'Artykuły', route: 'articles'},
                {icon: 'poll', text: 'Ankiety', route: 'surveys'},
                {icon: 'category', text: 'Kategorie', route: 'kbCategories'},



                // {divider: true, text: 'Chat'},
                // {icon: 'chat_bubble', text: 'Chat', route: 'chat'},

                {divider: true, text: 'Linki'},
                {icon: 'place', text: 'Placówki, obiekty, linki', route: 'links'},

                {divider: true, text: 'Wiadomości push'},
                {icon: 'notifications', text: 'Wiadomości push', route: 'push'},

                // {icon: 'cloud_upload', text: 'Stan publikacji', route: 'publications'},

                // {divider: true, text: 'Ustawienia'},
                // {icon: 'settings', text: 'Ustawienia', route: 'settings'},
            ],
            user: {
                type: 'admin', // 'redactor', 'teacher', 'coordinator'
                name: 'Piotr Kowalski',
                email: 'pkowalski@example.com',
            },
        }),
        props: {
            source: String,
        },
        methods: {
            logout () {
                this.$store.dispatch('logout')
            },
            globalDropHandler (e) {
                e.preventDefault();
            },
            goToErrorsPage () {
                this.$router.push({name: 'errors'})
            }
        },
        computed: {
            availableMenuItems () {
                return this.menuItems.filter(m => {
                    if (m.onlyForRoles) {
                        if (this.$store.state.me.roles) {
                            const myRoles = this.$store.state.me.roles || []
                            const commonRoles = m.onlyForRoles.filter(v => myRoles.indexOf(v) !== -1)
                            return commonRoles.length > 0
                        }

                        return false // -> just wait until we get 'me'
                    }

                    return true
                })
            },
            showRightMenu: {
                get () {
                    return this.$store.state.showRightMenu !== false
                },
                set () {

                }

            },
            hasErrors() {
                return this.$store.state.errors.length > 0;
            }
        },
        mounted () {
            window.addEventListener('drop', this.globalDropHandler);
            this.$on('hook:beforeDestroy', () => {
                window.removeEventListener('drop', this.globalDropHandler);
            })
        }

    }
</script>